import { render, staticRenderFns } from "./DigitalOrderShipment.vue?vue&type=template&id=0ea6ce08&scoped=true"
import script from "./DigitalOrderShipment.vue?vue&type=script&lang=js"
export * from "./DigitalOrderShipment.vue?vue&type=script&lang=js"
import style0 from "./DigitalOrderShipment.vue?vue&type=style&index=0&id=0ea6ce08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6ce08",
  null
  
)

export default component.exports